<app-spinner></app-spinner>
<mat-sidenav-container class="container">
  <mat-sidenav #sidebar mode="side">
    <div class="navbar">
      <div class="top">
        <mat-icon [inline]="true" (click)="logOut()" [matTooltip]="labels.closeSession">
          exit_to_app
        </mat-icon>
      </div>

      <div class="user">
        <mat-icon style="color: #185564">person</mat-icon>

        <h3 class="name">
          <strong>{{ UserName }}</strong>
        </h3>
      </div>
      <div class="rol">
        <h3 class="rolName">
          <strong>{{ AccessUser }}</strong>
        </h3>
      </div>

      <div class="menu">
        <div class="menu-head">
          <span></span>
        </div>
        <div class="menu-item">
          <mat-accordion multi>
            <!--  MÓDULO PDD  -->
            <mat-expansion-panel class="menu-panel">
              <mat-expansion-panel-header>
                <mat-panel-title>
                  <img class="logo" src="assets/img/PDD.png" alt="PDD" />
                  <span class="title">{{ labels.planDevelopment }}</span>
                </mat-panel-title>
              </mat-expansion-panel-header>
              <button mat-button class="menu-button" [routerLink]="['']">
                <span>{{ labels.empty }}</span>
              </button>
            </mat-expansion-panel>

            <!--  MÓDULO PAA  -->
            <mat-expansion-panel class="menu-panel">
              <mat-expansion-panel-header>
                <mat-panel-title style="margin-left: -2%">
                  <img class="logo" src="assets/img/PAA.png" alt="PAA" />&nbsp;
                  <span class="title">{{ labels.annualAcquisitionPlan }}</span>
                </mat-panel-title>
              </mat-expansion-panel-header>
              @if (
                AccessUser === 'Referente_PAA' ||
                AccessUser === 'Referente_Planeacion' ||
                AccessUser === 'Revisor'
              ) {
                <div>
                  <button
                    mat-button
                    class="menu-button"
                    [routerLink]="['paa/acquisitions']"
                    (click)="sidebar.toggle()"
                  >
                    &nbsp;<span>- {{ labels.paa }}</span>
                  </button>
                </div>
                @if (AccessUser === 'Referente_PAA') {
                  <div>
                    <button
                      mat-button
                      class="menu-button"
                      [routerLink]="['paa/task-tray']"
                      (click)="sidebar.toggle()"
                    >
                      &nbsp;<span>- {{ labels.taskTray }}</span>
                    </button>
                  </div>
                }
                <div>
                  <button
                    mat-button
                    class="menu-button"
                    [routerLink]="['paa/request-tray']"
                    (click)="sidebar.toggle()"
                  >
                    &nbsp;<span>- {{ labels.requestedModifications }}</span>
                  </button>
                </div>
                <div>
                  <button
                    mat-button
                    class="menu-button"
                    [routerLink]="['paa/reports']"
                    (click)="sidebar.toggle()"
                  >
                    &nbsp;<span>- {{ labels.reports }}</span>
                  </button>
                </div>
              }
            </mat-expansion-panel>

            <!--  MÓDULO POAI  -->
            <mat-expansion-panel class="menu-panel">
              <mat-expansion-panel-header>
                <mat-panel-title>
                  <img class="logo" src="assets/img/POAI.png" alt="POAI" />
                  <span class="title">{{ labels.operationalInvestmentPlan }}</span>
                </mat-panel-title>
              </mat-expansion-panel-header>
              <button mat-button class="menu-button" [routerLink]="['']">
                <span>{{ labels.empty }}</span>
              </button>
            </mat-expansion-panel>

            <!--  MÓDULO ADMIN  -->
            <mat-expansion-panel class="menu-panel admin-panel">
              <mat-expansion-panel-header>
                <mat-panel-title>
                  <mat-icon>admin_panel_settings</mat-icon>
                  <span class="title">{{ labels.administration }}</span>
                </mat-panel-title>
              </mat-expansion-panel-header>

              <div class="admin-menu-item">
                <button
                  mat-button
                  class="menu-button admin-menu-button"
                  [routerLink]="['admin/parameters']"
                  (click)="sidebar.toggle()"
                >
                  <span class="admin-menu-text">{{ labels.parameters }}</span>
                </button>
              </div>
              <div class="admin-menu-item">
                <button
                  mat-button
                  class="menu-button admin-menu-button"
                  [routerLink]="['admin/dependencies']"
                  (click)="sidebar.toggle()"
                >
                  <span class="admin-menu-text">{{ labels.dependencies }}</span>
                </button>
              </div>
              <div class="admin-menu-item">
                <button
                  mat-button
                  class="menu-button admin-menu-button"
                  [routerLink]="['admin/modalidades-seleccion']"
                  (click)="sidebar.toggle()"
                >
                  <span class="admin-menu-text">{{ labels.modalidadesSeleccion }}</span>
                </button>
              </div>
              <div class="admin-menu-item">
                <button
                  mat-button
                  class="menu-button admin-menu-button"
                  [routerLink]="['admin/tipos-contrato']"
                  (click)="sidebar.toggle()"
                >
                  <span class="admin-menu-text">{{ labels.tiposContrato }}</span>
                </button>
              </div>
              <div class="admin-menu-item">
                <button
                  mat-button
                  class="menu-button admin-menu-button"
                  [routerLink]="['admin/actuaciones-contractuales']"
                  (click)="sidebar.toggle()"
                >
                  <span class="admin-menu-text">{{ labels.actuacionesContractuales }}</span>
                </button>
              </div>
              <div class="admin-menu-item">
                <button
                  mat-button
                  class="menu-button admin-menu-button"
                  [routerLink]="['admin/perfiles']"
                  (click)="sidebar.toggle()"
                >
                  <span class="admin-menu-text">{{ labels.perfiles }}</span>
                </button>
              </div>
              <div class="admin-menu-item">
                <button
                  mat-button
                  class="menu-button admin-menu-button"
                  [routerLink]="['admin/rangos-salariales']"
                  (click)="sidebar.toggle()"
                >
                  <span class="admin-menu-text">{{ labels.rangosSalariales }}</span>
                </button>
              </div>
              <div class="admin-menu-item">
                <button
                  mat-button
                  class="menu-button admin-menu-button"
                  [routerLink]="['admin/contratos']"
                  (click)="sidebar.toggle()"
                >
                  <span class="admin-menu-text">{{ labels.contratos }}</span>
                </button>
              </div>
            </mat-expansion-panel>
          </mat-accordion>
        </div>
      </div>
    </div>
  </mat-sidenav>
  <mat-sidenav-content>
    <div class="content">
      <div class="toolbar">
        <mat-toolbar>
          <app-header (click)="sidebar.toggle()"></app-header>
        </mat-toolbar>
      </div>
      <div class="main">
        <router-outlet></router-outlet>
      </div>
    </div>
    <app-footer></app-footer>
  </mat-sidenav-content>
</mat-sidenav-container>
